import type { BuildJsonType } from '@bb/domain/dist/typeHelpers';
import type { IFrontEndInstructions } from '@bb/users';

export const getDate = (date: Date | string | undefined) => {
  if (typeof date === 'string') return new Date(date);
  return date;
};

export const transformFrontEndInstructions = (
  ins: IFrontEndInstructions | BuildJsonType<IFrontEndInstructions> | undefined,
): IFrontEndInstructions | undefined => {
  if (!ins) return undefined;

  return {
    ...ins,
    vacationDates: ins?.vacationDates && {
      ...ins.vacationDates,
      from: getDate(ins.vacationDates.from),
      to: getDate(ins.vacationDates.to),
    },
    forwardReps: ins?.forwardReps?.map(rep => ({
      ...rep,
      forwardRepsStart: getDate(rep.forwardRepsStart),
      forwardRepsExpiry: getDate(rep.forwardRepsExpiry),
    })),
  };
};
